import Vue from "vue";
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state:{
    userInfo:{}, // 当前登录用户
    selUserInfo:{} // 当前查看用户
  },
  getters:{
    userInfo: state => state.userInfo,
    selUserInfo: state => state.selUserInfo
  },
  mutations:{
    userInfo:(state,value) => state.userInfo = value,
    selUserInfo:(state,value) => state.selUserInfo = value,
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js